import classNames from 'classnames'
import { Product } from '~/types'
import { DeliveryMethodSection } from './DeliveryMethodSection'
import styles from './ProductDashboardShippingMethods.module.scss'
import {
  ProductDashboardStoreAvailabilityStatus,
  StoreAvailabilitySection,
} from './StoreAvailabilitySection'

export type ProductDashboardShippingMethodsProps = {
  product: Product
  storeAvailabilityStatus?: ProductDashboardStoreAvailabilityStatus
}

export const ProductDashboardShippingMethods = ({
  product,
  storeAvailabilityStatus,
}: ProductDashboardShippingMethodsProps) => {
  return (
    <div className={classNames(styles.root, 'mt-5')}>
      <DeliveryMethodSection product={product} />
      <StoreAvailabilitySection
        product={product}
        storeAvailabilityStatus={storeAvailabilityStatus}
      />
    </div>
  )
}
